<script lang="ts">
	import { EMBEDDING_MODELS } from 'src/constants/embeddings';
	import Select from '@astlai/common/Select.svelte';

	interface Props {
		embeddingsVendor: string;
		label?: string;
		onchange?: (v: string) => void;
	}

	let { embeddingsVendor = $bindable(), onchange = () => {}, label }: Props = $props();

	const grouped = Object.entries(
		Object.values(EMBEDDING_MODELS).reduce(
			(acc, val) => ({ ...acc, [val.vendor]: [...(acc[val.vendor] || []), val] }),
			{} as Record<string, { id: string; label: string; vendor: string }[]>
		)
	);
</script>

<Select {label} {onchange} bind:value={embeddingsVendor}>
	{#each grouped as [vendor, group]}
		<optgroup label={vendor}>
			{#each group as embModel}
				<option value={embModel.id}>{embModel.label}</option>
			{/each}
		</optgroup>
	{/each}
</Select>
